module.exports = __webpack_public_path__ + "img/4.8ec1bd28.png";